import { Route } from "react-router-dom";
let urlJson = {};
let pathKeyJson = {};
let keyTitleJson = {};
let parentKeys= {};
let keyCompKeepaliveId={}
 const renderSubRoutes = (parentPath,pKey,routerConfig) =>{
    let routes_sub = routerConfig.map((subItem,index) =>{
        urlJson[subItem.key] = "/home/"+ parentPath+"/"+subItem.path;
        pathKeyJson["/home/"+parentPath+"/"+subItem.path] = subItem.key
        keyTitleJson[subItem.key] = subItem.title;
        parentKeys[subItem.key] = pKey;
        if(subItem.name){
            keyCompKeepaliveId[subItem.key] = subItem.name;
        }
        return  <Route key={subItem.key} path={ subItem.path} element={subItem.element}/>;
    });
    routes_sub.push( <Route  index element={routerConfig[0].element}/>)
    return routes_sub;
}
const generateRouter = (menus)=>{
    return    ( menus || []).map((item,index) => {
        if(!item.children){
            let path = "/home/"+item.path;
            urlJson[item.key] = path;
            pathKeyJson[path] = item.key;
            keyTitleJson[item.key] = item.title;
            if(item.name){
                keyCompKeepaliveId[item.key] = item.name;
            }
            return <Route key={item.key} path={item.path} element={item.element}/>
        }else{
            urlJson[item.key] = item.path;
            pathKeyJson[item.path] = item.key;
            keyTitleJson[item.key] = item.title;
            if(item.name){
                keyCompKeepaliveId[item.key] = item.name;
            }
            return (<Route key={item.key} path={item.path+"/*"} element={item.element}>{renderSubRoutes(item.path,item.key,item.children)}</Route>)
        }
    })
}
const renderRouters = (menus) => { return generateRouter(menus)};
export default { renderRouters ,urlJson,pathKeyJson,keyTitleJson,parentKeys,keyCompKeepaliveId};